import Swiper from 'react-id-swiper'

import styled from 'styled-components'

import media from '../../../utils/media'
import Icon from '../../helpers/Icon'

export const CarouselWrapper = styled.div`
  width: 100%;
  
  ${({ marginTop }) =>
    marginTop &&
    `
    margin-top:${marginTop}px;
  `};

  .swiper-slide {
    height: auto;
  }

  .swiper-pagination-bullet {
    opacity: 1;
    width: 10px;
    height: 10px;
  }

  .swiper-container-horizontal {
    .swiper-pagination-bullets {
      bottom: -40px;
      &:not(.swiper-pagination-lock) {
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .swiper-pagination-bullet {
        margin: 0 8px;
      }
    }
  }

  ${({ theme, dotsColor }) =>
    dotsColor &&
    `
      .swiper-pagination-bullet {
        background-color: ${theme.color[dotsColor]};
      }
  `}

  ${({ theme, dotsActiveColor }) =>
    dotsActiveColor &&
    `
      .swiper-pagination-bullet-active {
        width: 14px;
        height: 14px;
        background-color: ${theme.color[dotsActiveColor]};
      }
  `}

  ${media.lessThan('sm')`
    ${({ fullMobile }) =>
      fullMobile &&
      `
        .swiper-container {
          display: flex;
          overflow: visible;
          width: 100%;
          flex-wrap: nowrap;
          align-items: stretch;
        }

        .swiper-slide {
          width: 80%;
        }
    `}
  `}

  ${media.lessThan('xs')`
    ${({ fullMobile }) =>
      fullMobile &&
      `
        .swiper-slide {
          width: 90% !important;
        }
    `}
  `}
`

export const Carousel = styled(Swiper)`
  .swiper-slide {
    height: 100%;
  }
`

export const CarouselButton = styled.button`
  box-shadow: none;
  background-color: transparent;
  border: none;
  display: block;
  width: 42px;
  height: 42px;
  overflow: hidden;
  position: absolute;
  top: 0;
  bottom: 0;
  margin: auto;
  z-index: 10;
  color: ${({ theme, navColor }) => theme.color[navColor]};
  span {
    text-indent: -9999px;
  }
  &:hover {
    transform: scale(1.2);
  }
`

export const CarouselPrev = styled(CarouselButton)`
  left: -20px;
`

export const CarouselNext = styled(CarouselButton)`
  right: -20px;
`

export const CarouselIcon = styled(Icon)`
  width: 100% !important;
  height: 100% !important;
`
